import { Pipe, PipeTransform } from "@angular/core";
import { Location } from "src/app/model/dispatch.model";

@Pipe({
  name: 'readLocation'
})
export class ReadLocationPipe implements PipeTransform {
  /**
   * Transform location model into human-readable location.
   * @param loc Location model.
   * @returns Human-readable location.
   */
  public transform(location?: Location) {
    return location?.short_text ?? location?.long_text ?? [
      location?.street_no,
      location?.street,
      location?.city,
      location?.suburb,
      location?.state?.abbreviation.toString(),
      location?.postal_code.toString()
    ]
    .filter((info) => info && info.trim().length)
    .filter((info, index, self) => self.findIndex((lookup) => lookup === info) === index)
    .join(', ');
  }
}
